import { render, staticRenderFns } from "./public-product-item-card.vue?vue&type=template&id=8efd4368&scoped=true&lang=pug"
import script from "./public-product-item-card.js?vue&type=script&lang=js&external"
export * from "./public-product-item-card.js?vue&type=script&lang=js&external"
import style0 from "./public-product-item-card.vue?vue&type=style&index=0&id=8efd4368&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8efd4368",
  null
  
)

export default component.exports